import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { ProjectUserStore } from "../domain/project-users.model";

export const fetchProjectUserList = createAsyncThunk<
  any[],
  { id: string; type: "npms" | "eci" | "custom" }
>("projectUsers/fetchProjectUsers", async ({ id, type }) => {
  let url = `${AppConstants.api}/user/`;
  if (type === "npms") url += `list-by-npms`;
  if (type === "eci") url += `list-by-eci`;
  if (type === "custom") url += `list-by-custom`;

  const response = await api.get<ApplicationResponse<any[]>>(url, {
    params: {
      id,
    },
  });
  return response.data.data || [];
});

export const updateProjectUser = createAsyncThunk<
any,
{projectId: string,projectType: "npms" | "eci" | "custom",oldHOSId: string,newHOSId:string}
>("projectUsers/updateProjectUser",async ({projectId,projectType,oldHOSId,newHOSId}) => {
   const url = `${AppConstants.api}/project/update-hos?projectType=${projectType}&projectId=${projectId}&oldHOSId=${oldHOSId}&newHOSId=${newHOSId}`;
    const response = await api.put<ApplicationResponse<any>>(url);
  return response.data.data || [];
})

export const updateCheckerOrApprover = createAsyncThunk<any,
    {projectId: string, previous_user: string,updated_user:string,type: "checker" | "approver"}>
("projectUsers/updateCheckerOrApprover",async ({projectId,previous_user,updated_user, type}) => {
  const url = `${AppConstants.api}/project/update-checker-approver?project_id=${projectId}&previous_user=${previous_user}&updated_user=${updated_user}&type=${type}`;
  return await api.put<ApplicationResponse<any>>(url);
})


const ProjectUsersSlice = createSlice({
  name: "projectUsers",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as ProjectUserStore,
  reducers: {
    resetProjectUsers: (state) => {
      state.minimal = {
        status: "loading",
        error: null,
        data: [],
      };
    },
    updateProjectUsers: (state, action) => {
      state.minimal.data.push(action.payload);
    },
    removeUser: (state, action) => {
      state.minimal.data = state.minimal.data.filter(
        (user: any) => user.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectUserList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchProjectUserList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchProjectUserList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      // .addCase(updateProjectUser.pending, (state, action) => {
      //   state.minimal = {
      //     status: "loading",
      //     data: [],
      //     error: null,
      //   };
      // })
      // .addCase(updateProjectUser.fulfilled, (state, action) => {
      //   state.minimal = {
      //     status: "idle",
      //     data: action.payload,
      //     error: null,
      //   };
      // })
      // .addCase(updateProjectUser.rejected, (state, action) => {
      //   state.minimal = {
      //     status: "failed",
      //     data: [],
      //     error: action.error,
      //   };
      // });
  },
});
export const { removeUser, updateProjectUsers, resetProjectUsers } =
  ProjectUsersSlice.actions;

export default ProjectUsersSlice.reducer;
